import {
	setAvatar,
	changePhone,
	changePwd,
	changeSupplierDrawingBill,
	changeRemind,
	moneyData,
	paymentCode,
	mywalletCheckPayState,
	tixianInfo,
	tixianData,
	walletData,
	zfbList,
	zfbAdd,
	zfbDelete,
	zfbEdit,
	zfbSet,
	usableBank,
	bankList,
	bankAdd,
	bankDelete,
	bankEdit,
	bankSet,
	productTaskList,
	productTaskAdd,
	productTaskDel,
	productQueueList,
	productList,
	productDel,
	productBatOnSale,
	productBatOffSale,
	productFilterData,
	productLeafCateList,
	batProductEditPrice,
	productEditInfo,
	supplierAddress,
	supplierAddressEdit,
	supplierRegionList,
	supplierOrderList,
	supplierOrderFilterData,
	supplierOrderAddressInfo,
	supplierOrderDetail,
	supplierOrderDeliver,
	supplierOrderDeliverInfo,
	supplierGetOperateInfo,
	supplierOpAfterSale,
	supplierAuditRefund,
	supplierKdnLcb,
	unboundLogisticsCompany,
	subBindLogisticsCompany,
	delBindLogisticsCompany,
	extendUrl,
	extendList,
	boundLogisticsCompany,
	createPrintOrder,
	orderPrintInfo,
	batDeliverOrderData,
	supplierOrderTrackDetail,
	supplierRoleIndex,
	supplierRoleMenus,
	supplierRoleAdd,
	supplierRoleUpdate,
	supplierRoleDel,
	supplierRoleInfo,
	supplierRoleExt,
	agentuserIndex,
	agentuserFieldList,
	agentuserAdd,
	agentuserDel,
	agentuserInfo,
	agentuserUpdate,
	agentuserResetPwd,
	agentuserExt,
	supplierNetsite,
	supplierCancelBill,
	supplierPrintInfo,
	shelvesList,
	shelvesAdd,
	shelvesInfo,
	shelvesUpdate,
	shelvesDel,
	allocationList,
	allocationAdd,
	allocationDel,
	stallsList,
	stallsAdd,
	stallsInfo,
	stallsUpdate,
	stallsDel,
	allStallsList,
	supplierMakeOrderBills,
	orderBills,
	makeOrderProductTags,
	orderTags,
	editFreightPrice,
	setDefaultNetsite,
	editOrderProductRemark,
	orderProductOutOfStock,
	orderAutoPrintDelivery,
	orderCancelBill,
	supplierShopList,
	syncProduct,
	ddShopList, ddShopDel, ddSetDefaultShareBill, ddShopNetSiteList, puhuoErrorCollectList, deletePhError,
	productInviteCode,
	updateProductInviteCode
} from "../../../api/main/ucenter.js";
import {userinfoData} from "../../../api/main/login.js";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {

	},
	actions: {
		getUserinfoData(conText, payload){//获取个人信息
			userinfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		changeAvatar(conText, payload){//更换头像
			setAvatar(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePhone(conText, payload){//换绑手机号
			changePhone(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePwd(conText, payload){//更改密码
			changePwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeSupplierDrawingBill(conText, payload){//更改供应商发货运费
			changeSupplierDrawingBill(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeRemind(conText, payload){//接收公众号提醒
			changeRemind(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetZfbList(conText, payload){//获取支付宝列表
			zfbList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doZfbAdd(conText, payload){//新增支付宝账户
			zfbAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doZfbDelete(conText, payload){//删除支付宝账户
			zfbDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doZfbEdit(conText, payload){//编辑支付宝账户
			zfbEdit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doZfbSet(conText, payload){//选择默认支付宝账户
			zfbSet(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetUsableBank(conText, payload){//获取可选银行列表
			usableBank(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetBankList(conText, payload){//获取银行卡列表
			bankList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doBankAdd(conText, payload){//新增银行卡账户
			bankAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doBankDelete(conText, payload){//删除银行卡账户
			bankDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doBankEdit(conText, payload){//编辑银行卡账户
			bankEdit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doBankSet(conText, payload){//选择默认银行卡账户
			bankSet(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},





		getMoneyData(conText, payload){//获取钱包金额信息
			moneyData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getTixianInfo(conText, payload){//获取提现信息
			tixianInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doTixian(conText, payload){//发起提现
			tixianData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWallteData(conText, payload){//获取钱包记录流水
			walletData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getPaymentCode(conText, payload){//获取支付二维码
			paymentCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getMywalletCheckPayState(conText, payload){//查询充值情况
			mywalletCheckPayState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		// 商品相关
		getProductTaskList(conText, payload){//复制商品任务
			productTaskList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductTaskAdd(conText, payload){//一键复制
			productTaskAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductTaskDel(conText, payload){//删除任务
			productTaskDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductQueueList(conText, payload){//复制商品任务明细
			productQueueList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductList(conText, payload){//商品列表
			productList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getPuhuoErrorCollectList(conText, payload){//商品列表
			puhuoErrorCollectList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDeletePhError(conText, payload){//删除铺货异常记录
			deletePhError(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductDel(conText, payload){//删除商品
			productDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBatOnSale(conText, payload){//商品批量上架
			productBatOnSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBatOffSale(conText, payload){//商品批量下架
			productBatOffSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductFilterData(conText, payload){//商品搜索数据
			productFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductLeafCateList(conText, payload){//商品搜索数据
			productLeafCateList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatProductEditPrice(conText, payload){//商品批量改价
			batProductEditPrice(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductEditInfo(conText, payload){//商品信息
			productEditInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierAddress(conText, payload){//地址管理
			supplierAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierAddressEdit(conText, payload){//地址管理-编辑
			supplierAddressEdit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierRegionList(conText, payload){//获取下级地区列表
			supplierRegionList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		// 订单管理
		getSupplierOrderList(conText, payload){//订单列表
			supplierOrderList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierOrderAddressInfo(conText, payload){//查看收货人信息
			supplierOrderAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierOrderFilterData(conText, payload){//订单筛选数据
			supplierOrderFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierOrderDetail(conText, payload){//订单详情
			supplierOrderDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierOrderDeliver(conText, payload){//订单发货
			supplierOrderDeliver(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierOrderDeliverInfo(conText, payload){//订单发货信息
			supplierOrderDeliverInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierGetOperateInfo(conText, payload){//售后操作数据
			supplierGetOperateInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postSupplierOpAfterSale(conText, payload){//售后操作执行
			supplierOpAfterSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postSupplierAuditRefund(conText, payload){//已发货仅退款审核（抖店自动同意退款的情况）
			supplierAuditRefund(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierKdnLcb(conText, payload){//已绑定合作网点列表
			supplierKdnLcb(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getUnboundLogisticsCompany(conText, payload){//未绑定合作网点快递公司列表
			unboundLogisticsCompany(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubBindLogisticsCompany(conText, payload){//添加绑定网点账号的物流公司
			subBindLogisticsCompany(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDelBindLogisticsCompany(conText, payload){//删除绑定网点账号的物流公司
			delBindLogisticsCompany(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendUrl(conText, payload){//获取推广中心链接
			extendUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendList(conText, payload){//获取推广中心合作列表
			extendList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBoundLogisticsCompany(conText, payload){//获取已绑定合作网点的物流公司
			boundLogisticsCompany(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCreatePrintOrder(conText, payload){//提交生成电子面单
			createPrintOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderPrintInfo(conText, payload){//获取单个电子面单信息
			orderPrintInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBatDeliverOrderData(conText, payload){//获取打单发货的待发货信息
			batDeliverOrderData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierOrderTrackDetail(conText, payload){//获取物流轨迹
			supplierOrderTrackDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},


		//////////////////////////////////////
		getSupplierRoleIndex(conText, payload){//岗位管理列表
			supplierRoleIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierRoleMenus(conText, payload){//权限系统获取菜单
			supplierRoleMenus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierRoleAdd(conText, payload){//添加岗位
			supplierRoleAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierRoleUpdate(conText, payload){//更新岗位设置
			supplierRoleUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierRoleDel(conText, payload){//删除岗位
			supplierRoleDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierRoleInfo(conText, payload){//岗位信息
			supplierRoleInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierRoleExt(conText, payload){//岗位禁用状态
			supplierRoleExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserIndex(conText, payload){//员工列表
			agentuserIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserFieldList(conText, payload){//获取岗位信息
			agentuserFieldList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserAdd(conText, payload){//添加员工
			agentuserAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserDel(conText, payload){//删除员工
			agentuserDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserInfo(conText, payload){//查询员工修改信息
			agentuserInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserUpdate(conText, payload){//更新员工
			agentuserUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserResetPwd(conText, payload){//重置密码
			agentuserResetPwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserExt(conText, payload){//修改员工显示状态
			agentuserExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierNetsite(conText, payload){//获取已绑定快递网点
			supplierNetsite(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierCancelBill(conText, payload){//取消电子面单（抖店）
			supplierCancelBill(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSupplierPrintInfo(conText, payload){//获取订单打印信息（抖店）
			supplierPrintInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShelvesList(conText, payload){//添加货架
			shelvesList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShelvesAdd(conText, payload){//添加货架
			shelvesAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShelvesInfo(conText, payload){//货架信息
			shelvesInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShelvesUpdate(conText, payload){//更新货架
			shelvesUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShelvesDel(conText, payload){//删除货架
			shelvesDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAllocationList(conText, payload){//货位列表
			allocationList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAllocationAdd(conText, payload){//添加货位
			allocationAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAllocationDel(conText, payload){//删除货位
			allocationDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getStallsList(conText, payload){//档口列表
			stallsList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opStallsAdd(conText, payload){//添加档口
			stallsAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getStallsInfo(conText, payload){//档口信息
			stallsInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opStallsUpdate(conText, payload){//更新档口
			stallsUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opStallsDel(conText, payload){//删除档口
			stallsDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAllStallsList(conText, payload){//全部档口
			allStallsList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSupplierMakeOrderBills(conText, payload){//生成进货单据信息
			supplierMakeOrderBills(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderBills(conText, payload){//分页获取进货单打印
			orderBills(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opMakeOrderProductTags(conText, payload){//生成订单商品标签记录
			makeOrderProductTags(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderTags(conText, payload){//分页获取订单商品标签打印
			orderTags(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditFreightPrice(conText, payload){//更新供应商统一运费
			editFreightPrice(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetDefaultNetsite(conText, payload){//设置供应商默认快递网点
			setDefaultNetsite(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditOrderProductRemark(conText, payload){//订单商品表备注
			editOrderProductRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderProductOutOfStock(conText, payload){//订单商品缺货
			orderProductOutOfStock(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderAutoPrintDelivery(conText, payload){//自动打单发货（新）
			orderAutoPrintDelivery(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderCancelBill(conText, payload){//取消面单（新）
			orderCancelBill(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getSupplierShopList(conText, payload){//抖店列表
			supplierShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSyncProduct(conText, payload){//同步抖店商品
			syncProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		//我的抖店
		getDdShopList(conText, payload){//抖店列表
			ddShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDdShopDel(conText, payload){//删除抖店
			ddShopDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		setDefaultShareBill(conText, payload){//删除抖店
			ddSetDefaultShareBill(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDdShopNetSiteList(conText, payload){//抖店列表
			ddShopNetSiteList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductInviteCode(conText, payload){
			productInviteCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateProductInviteCode(conText, payload){
			updateProductInviteCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},


	}

}
export default modules;
